"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevelopmentDocumentType = void 0;
var DevelopmentDocumentType;
(function (DevelopmentDocumentType) {
    DevelopmentDocumentType[DevelopmentDocumentType["SalesBrochure"] = 1] = "SalesBrochure";
    DevelopmentDocumentType[DevelopmentDocumentType["PriceList"] = 2] = "PriceList";
    DevelopmentDocumentType[DevelopmentDocumentType["SalesArrangement"] = 3] = "SalesArrangement";
    DevelopmentDocumentType[DevelopmentDocumentType["RegisterOfTransaction"] = 4] = "RegisterOfTransaction";
    DevelopmentDocumentType[DevelopmentDocumentType["DeedOfMutualConvenant"] = 5] = "DeedOfMutualConvenant";
    DevelopmentDocumentType[DevelopmentDocumentType["FloorPlan"] = 6] = "FloorPlan";
    DevelopmentDocumentType[DevelopmentDocumentType["DevelopmentPlan"] = 7] = "DevelopmentPlan";
    DevelopmentDocumentType[DevelopmentDocumentType["BirdsEyeView"] = 8] = "BirdsEyeView";
    DevelopmentDocumentType[DevelopmentDocumentType["BallotResult"] = 9] = "BallotResult";
})(DevelopmentDocumentType = exports.DevelopmentDocumentType || (exports.DevelopmentDocumentType = {}));
